import React from "react";
import { ArrowUpRight } from "lucide-react";
import { BUILD_TYPES } from "../mock";

const BuildTypes = () => {
  return (
    <section id="build-types" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-[#DC2626]">
            Any structure
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-700 tracking-tight text-[#0A2540]">
            Built for every project
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Residential to heavy industrial — pick a category and get costs tuned to it.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BUILD_TYPES.map((b) => (
            <div
              key={b.id}
              className="group relative rounded-2xl overflow-hidden shadow-sm ring-1 ring-slate-200 cursor-pointer"
            >
              <img
                src={b.image}
                alt={b.name}
                className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540] via-[#0A2540]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                <div className="flex items-center justify-between">
                  <h3 className="font-display text-lg font-600">{b.name}</h3>
                  <ArrowUpRight className="h-5 w-5 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <p className="mt-1 text-sm text-slate-200 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-20 transition-all duration-300">
                  {b.blurb}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuildTypes;
